import { useLayoutEffect } from 'react';
import { Navigate } from 'react-router-dom';

import Loader from '~/common/components/utils/Loader.tsx';
import useAuth from '~/features/auth/hooks/useAuth.ts';
import { getAccessToken, setAuthData } from '~/features/auth/utils/auth.util.ts';

import type { PropsWithChildren } from 'react';

function AuthGuard({ children }: PropsWithChildren) {
  const {
    state: { authUser },
    fetchAuthUser,
  } = useAuth();

  const accessToken = getAccessToken();

  useLayoutEffect(() => {
    if (authUser || !accessToken) return;

    setAuthData(accessToken);
    fetchAuthUser();
  }, [authUser, accessToken]);

  // 토큰이 없으면 로그인 페이지로 리다이렉트
  if (!accessToken) {
    return <Navigate to="/auth/sign-in" replace />;
  }

  return authUser ? children : <Loader fullScreen />;
}

export default AuthGuard;
